import React, { useEffect, useState } from "react";

//Import Breadcrumb
import { FormLabel, Grid, InputAdornment, MenuItem, Select, Stack, TextField } from "@mui/material";
import { Button } from "reactstrap";
import CustomSelect from "../../components/Form/CustomSelect";
import Helpers from "../../helpers/helpers";
import CustomizedDatePicker from "../../components/Form/DatePicker";
import AppDialog from "../../components/Common/AppDialog";

const ProductFilterContent = (props) => {

    const clear = () => {
        let resetFilter = {
            race_id: null,
            nationality: null,
            registeredDateFrom: null,
            registeredDateTo: null,
            customer_group_id: null,
            blacklist: null
        }
        setFormValues({ ...resetFilter });
        props.onChange(resetFilter);
    }

    useEffect(() => {
        setFormValues(props?.formValue);
    }, []);

    const [formValues, setFormValues] = useState();

    const handleFormValueChange = (field, val) => {
        let data = formValues;
        data[field] = val
        setFormValues({ ...data });
        props.onChange(data);
    }

    return (
        <React.Fragment>
            <AppDialog
                open={props.open}
                close={() => props.close(false)}
                title={'Filters'}
                negativeTitle={'Reset'}
                negativeButtonStyle={{ border: '0px', backgroundColor: 'transparent', color: '#505D69', textDecoration: 'underline' }}
                negativePress={() => { clear() }}
                positivePress={() => props.close(false)}
                positiveTitle={'Show Results'}
                height={'80%'}
                width={'40%'}
                actionButtonStyle={'justify-content-between'}
            >
                <Stack flexDirection={"column"} pb={2}>
                    <CustomSelect
                        title={'Race'}
                        values={formValues?.race_id || '-1'}
                        placeholder={'Choose'}
                        data={props?.raceList || []}
                        onChange={(e) => handleFormValueChange('race_id', e)}
                    />
                </Stack>
                <Stack flexDirection={"column"} pb={2}>
                    <CustomSelect
                        title={'Nationality'}
                        values={formValues?.nationality || '-1'}
                        placeholder={'Choose'}
                        data={Helpers.nationalities}
                        onChange={(e) => handleFormValueChange('nationality', e)}
                    />
                </Stack>
                <Grid container spacing={2} pb={2}>
                    <Grid item xs={6}>
                        <CustomizedDatePicker
                            title={"Registered Date From"}
                            values={(formValues?.registeredDateFrom && new Date(formValues.registeredDateFrom ))}
                            placeholder={"DD/MM/YYYY"}
                            setFormValues={(e) => handleFormValueChange('registeredDateFrom', e)}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <CustomizedDatePicker
                            values={(formValues?.registeredDateTo && new Date(formValues.registeredDateTo))}
                            placeholder={"DD/MM/YYYY"}
                            title={"Registered Date To"}
                            setFormValues={(e) => handleFormValueChange('registeredDateTo', e)}
                            check={true}
                        />
                    </Grid>
                </Grid>
                <Stack flexDirection={"column"} pb={2}>
                    <CustomSelect
                        title={'Customer Group'}
                        values={formValues?.customer_group_id || '-1'}
                        placeholder={'Choose'}
                        data={Helpers.customerGroup}
                        onChange={(e) => handleFormValueChange('customer_group_id', e)}
                    />
                </Stack>
                <Stack flexDirection={"column"} pb={2}>
                    <CustomSelect
                        title={'Blacklisted'}
                        values={formValues?.blacklist || '-1'}
                        placeholder={'Choose'}
                        data={Helpers.blacklist}
                        onChange={(e) => handleFormValueChange('blacklist', e)}
                    />
                </Stack>
            </AppDialog>
        </React.Fragment>
    );
};

export default ProductFilterContent;
